export { BannersSliderSecondary } from './BannersSliderSecondary';
